import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'op_defs_list_page' */ './OpDefListPage'),
);
